import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

interface ValidationDialogProps {
  open: boolean;
  onClose: () => void;
  validationErrors: string[];
  onNavigateToSection: () => void;
}

const ValidationDialog: React.FC<ValidationDialogProps> = ({
  open,
  onClose,
  validationErrors,
  onNavigateToSection
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="validation-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="validation-dialog-title" sx={{ bgcolor: 'error.light', color: 'error.contrastText' }}>
        Please Complete Required Fields
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            The following fields need to be completed before submitting your application:
          </Typography>
          <List>
            {validationErrors.map((error, index) => (
              <ListItem key={index}>
                <ListItemText primary={error} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button onClick={onNavigateToSection} variant="contained" color="primary">
          Go to Section
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationDialog;
